import React, { type FunctionComponent, useState, SyntheticEvent } from 'react';
import { getWindow } from '@surfline/web-common';
import { AppBar, Box, Tab, Tabs, Toolbar } from '@mui/material';
import { useUserPermissionStatus } from 'selectors/user';

import Styles from './TravelNavbar.module.scss';

const modules = [
  { title: 'The waves', href: 'the-waves' },
  { title: 'When to score', href: 'when-to-score' },
  { title: 'Local knowledge', href: 'local-knowledge' },
  { title: 'Travel essentials', href: 'travel-essentials' },
  { title: 'Explore other zones', href: 'explore-other-zones' },
];

export const TravelNavbar: FunctionComponent = () => {
  const [value, setValue] = useState(0);
  const { hasAdFreePermissions } = useUserPermissionStatus();

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleClick = (id: string) => {
    const element = document?.getElementById(id);
    const headerOffset = 45;
    const elementPosition = element?.getBoundingClientRect()?.top;
    if (elementPosition !== undefined) {
      const offsetPosition = elementPosition + getWindow().pageYOffset - headerOffset;
      getWindow()?.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  const appBarColor = '#ffffff';

  return (
    <AppBar
      position={hasAdFreePermissions ? 'sticky' : 'static'}
      className={Styles.appBar}
      elevation={1}
      data-testid="travel-zone-navbar"
      sx={{ background: appBarColor }}
    >
      <Toolbar disableGutters variant="regular" className={Styles.toolbar}>
        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' } }}>
          <Tabs
            value={value}
            onChange={handleChange}
            slotProps={{
              indicator: { style: { backgroundColor: '#fff' } },
            }}
          >
            {modules.map(({ title, href }) => (
              <Tab
                key={title}
                label={title}
                onClick={() => handleClick(href)}
                className={Styles.tab}
                disableFocusRipple
                disableRipple
              />
            ))}
          </Tabs>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
export default TravelNavbar;
